import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-toggle-icon',
  templateUrl: './text-toggle.component.html'
})
export class TextToggleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
